import { api } from '@/core/api/';

const baseApiURL = 'api/budgethistory';

export const getBudgetHistory = (params) => {
  return api.get(`${baseApiURL}/`, { params });
};
